import type { FolderItem } from "@/lib/api";

interface FavoriteStarButtonProps {
  folder: FolderItem;
  onToggle: (folder: FolderItem) => void;
  /** Quem desenha a estrela vazia só no hover põe `group` no contêiner. */
  className?: string;
}

/**
 * Estrela da pasta favorita. Cheia, fica sempre à vista e tira o favorito;
 * vazia, aparece no hover (ou no foco do teclado) e favorita. O menu de
 * contexto da pasta tem o mesmo comando, para quem não tem hover.
 */
export function FavoriteStarButton({ folder, onToggle, className = "" }: FavoriteStarButtonProps) {
  const favorite = folder.favorite === true;
  return (
    <button
      type="button"
      aria-pressed={favorite}
      aria-label={favorite ? `Remover a pasta ${folder.name} dos favoritos` : `Favoritar a pasta ${folder.name}`}
      title={favorite ? "Remover dos favoritos" : "Favoritar: a pasta fica no início"}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onToggle(folder);
      }}
      className={`rounded p-1 transition hover:bg-ink-700 ${
        favorite
          ? "text-amber-400 hover:text-amber-300"
          : "text-ink-500 opacity-0 hover:text-amber-300 focus-visible:opacity-100 group-hover:opacity-100"
      } ${className}`}
    >
      <svg
        className="h-5 w-5"
        viewBox="0 0 24 24"
        fill={favorite ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth={favorite ? 0 : 1.75}
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 3.2l2.7 5.6 6.1.8-4.5 4.2 1.1 6.1L12 17l-5.4 2.9 1.1-6.1-4.5-4.2 6.1-.8z" />
      </svg>
    </button>
  );
}
